import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const DEFAULT_FALLBACK = '/dashboard';

const useBackNavigation = (fallbackPath = DEFAULT_FALLBACK) => {
  const location = useLocation();
  const navigate = useNavigate();

  return useCallback(() => {
    if (location.key !== 'default') {
      navigate(-1);
      return;
    }

    navigate(location.state?.backTo || fallbackPath);
  }, [fallbackPath, location.key, location.state, navigate]);
};

export default useBackNavigation;
